// import { Rocket } from "lucide-react";
// import './WaitingRoom.css';
// import { useState, useEffect } from 'react';

// const WaitingRoom = ({ urlArrived, onJoinSession,onBack }) => {
//     const [timedOut, setTimedOut] = useState(false);

//   useEffect(() => {
//     if (urlArrived) return;
//     const timer = setTimeout(() => setTimedOut(true), 65000);
//     return () => clearTimeout(timer);
//   }, [urlArrived]);

//   return (
//     <div className="waiting-room-overlay">
//       <div className="waiting-room-container">
//         {/* Header */}
//         <div className="waiting-room-header">
//           <h1>Preparing Your Session</h1>
//           <p>
//             {timedOut
//               ? "We're currently experiencing high request traffic. Please try again later."
//               : urlArrived
//                 ? "Your session is ready! Click below to join."
//                 : "We're customizing your session and tailor making it as per your requirement. Please hang tight..."}
//           </p>
//         </div>

//         {/* YouTube Video */}
//         <div className="waiting-room-video">
//           <iframe
//             src="https://www.youtube.com/embed/N8iuspNvgrw?autoplay=1&mute=1"
//             title="BotGuru Tips"
//             frameBorder="0"
//             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//             allowFullScreen
//           />
//         </div>

// {/* Join Button */}        
//         <div className="waiting-room-footer">
//           {timedOut ? (
//             <button className="join-session-btn ready" onClick={onBack}>
//               Go Back
//             </button>
//           ) : urlArrived ? (
//             <button className="join-session-btn ready" onClick={onJoinSession}>
//               <Rocket size={20} />
//               Join Session
//             </button>
//           ) : (
//             <button className="join-session-btn waiting" disabled>
//               <div className="join-spinner" />
//               Setting up your session...
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };


// export default WaitingRoom;

import { Rocket, CheckCircle2, Loader2, Clock } from "lucide-react";
import './WaitingRoom.css';
import { useState, useEffect } from 'react';

const steps = [
    {
      label: "Starting bot",
      desc: "Initializing your bot instance",
    },
    {
      label: "Connecting",
      desc: "Establishing a secure connection",
    },
    {
      label: "Almost ready",
      desc: "Running final checks",
    },
    {
      label: "Ready",
      desc: "Your bot session is live",
    },
  ];

const WaitingRoom = ({ urlArrived, onJoinSession, onBack }) => {
  const [timedOut, setTimedOut] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    if (urlArrived) return;
    const timer = setTimeout(() => setTimedOut(true), 65000);
    return () => clearTimeout(timer);
  }, [urlArrived]);

  // Advance steps every ~15s while waiting
  useEffect(() => {
    if (urlArrived || timedOut) return;
    if (activeStep >= steps.length - 2) return;
    const t = setTimeout(() => setActiveStep(s => s + 1), 15000);
    return () => clearTimeout(t);
  }, [activeStep, urlArrived, timedOut]);

  // Jump to last step when ready
  useEffect(() => {
    if (urlArrived) setActiveStep(steps.length - 1);
  }, [urlArrived]);

  const getStepState = (i) => {
    if (urlArrived) return i === steps.length - 1 ? "active" : "done";
    if (i < activeStep) return "done";
    if (i === activeStep) return "active";
    return "pending";
  };

  return (
    <div className="waiting-room-overlay">
      <div className="waiting-room-container">

        {/* Left: Video */}
                {!timedOut && (
        <div className="waiting-room-left">
            <iframe
            src="https://www.youtube.com/embed/N8iuspNvgrw?autoplay=1&controls=0&rel=0&modestbranding=1&loop=1&playlist=N8iuspNvgrw&disablekb=1"
            title="BotGuru Tips"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            />
        </div>
        )}

        {/* Right: Info Panel */}
        <div className={`waiting-room-right ${timedOut ? "timeout-mode" : ""}`}>

          <div className="waiting-room-info">
            {/* Badge */}
            <div className="waiting-room-badge">
              <span className="waiting-room-badge-dot" />
              {timedOut ? "High Traffic" : urlArrived ? "Session Ready" : "Setting Up"}
            </div>

            {/* Title */}
            <h1 className={urlArrived ? "status-ready" : ""}>
              {timedOut
                ? "High Request Traffic"
                : urlArrived
                ? "Your Session is Ready!"
                : "Preparing Your Session"}
            </h1>

            {/* Description */}
            <p>
              {timedOut
                ? "We're experiencing high traffic right now. Please go back and try again in a moment."
                : urlArrived
                ? "Everything is set up and personalized for you. Click below to launch your workspace."
                : "We're customizing your session and tailor making it as per your requirement. Please hang tight..."}
                </p>

            <div className="waiting-room-divider" />

            {/* Steps */}
            <div className="waiting-room-steps">
              {steps.map((step, i) => {
                const state = getStepState(i);
                return (
                  <div className="waiting-room-step" key={i}>
                    <div className={`step-icon ${state}`}>
                      {state === "done" ? "✓" : i + 1}
                    </div>
                    <div className="step-text">
                      <span className="step-label">{step.label}</span>
                      <span className="step-desc">{step.desc}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Footer */}
          <div className="waiting-room-footer">
            {!urlArrived && !timedOut && (
              <p className="waiting-room-tip">
                While you wait, watch a quick tip on getting the most out of your session.
              </p>
            )}

            {timedOut ? (
              <button className="join-session-btn ready" onClick={onBack}>
                Go Back
              </button>
            ) : urlArrived ? (
              <button className="join-session-btn ready" onClick={onJoinSession}>
                <Rocket size={18} />
                Join Session
              </button>
            ) : (
              <button className="join-session-btn waiting" disabled>
                <div className="join-spinner" />
                Setting up your session...
              </button>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default WaitingRoom;